import { render } from "./CBAnket.vue?vue&type=template&id=244f491c&scoped=true"
import script from "./CBAnket.vue?vue&type=script&lang=js"
export * from "./CBAnket.vue?vue&type=script&lang=js"

import "./CBAnket.vue?vue&type=style&index=0&id=244f491c&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244f491c"]])

export default __exports__